module.exports = __webpack_public_path__ + "img/图片9.ac7385b1.png";